// extracted by mini-css-extract-plugin
module.exports = {"checkBoxElement":"_3eJCD7ROt9Pm00lyWv440X"};